import * as caseCreateAction from './actions.js'
const caseCreateReducer = (state = {
    searchParam: [],
    counterparty: [],
    counterpartyPageNo: 1,
    counterpartyPageSize: 10,
    counterpartyHasNext: false,
    counterpartyLoading: false,
    counterpartySearchContext: null,
    selectedCounterparty: {},
    corporate: [],
    selectedCorporate: {},
    dropdownData: [],
    products: [],
    selectedUser: {},
    selectedProduct: {},
    result: {},
    createCounterParty: false,
    createdCounterParty: [],
    zoneList: [],
    portfolioCountData: [],
    statesList: [],
    productsFailure: [],
    allDivisionSubsidiary:[],
    allDivisionSubsidiaryFailure:[],
    reportCategorytData:[],
    reportFrontCoverList :[],
}, action) => {
    switch (action.type) {

        case caseCreateAction.SET_SEARCH_PARAMETER:

            state = {
                ...state,
                company: { ...action.payload }
            };
            break;
        case caseCreateAction.SELECTED_PRODUCT:

            state = {
                ...state,
                selectedProduct: action.payload
            };
            break;
        case caseCreateAction.SELECTED_CORPORATE:

            state = {
                ...state,
                selectedCorporate: action.payload
            };
            break;
        case caseCreateAction.SELECTED_COUNTERPARTY:

            state = {
                ...state,
                selectedCounterparty: action.payload
            };
            break;
        case caseCreateAction.SELECTED_USER:

            state = {
                ...state,
                selectedUser: action.payload
            };
            break;
        case caseCreateAction.CLEAR_DATA:
            state = {
                searchParam: [],
                counterparty: [],
                counterpartyPageNo: 1,
                counterpartyPageSize: 10,
                counterpartyHasNext: false,
                counterpartyLoading: false,
                counterpartySearchContext: null,
                selectedCounterparty: {},
                corporate: [],
                selectedCorporate: {},
                dropdownData: [],
                products: [],
                selectedUser: {},
                selectedProduct: {},
                result: {},
                createCounterParty: false,
                createdCounterParty: [],
                allDivisionSubsidiary:[],
                allDivisionSubsidiaryFailure:[],
                reportCategorytData:[],
                reportFrontCoverList :[],
            };
            break;
        case caseCreateAction.CLEAR_RESULT:
            state = {
                ...state,
                result: {}
            };
            break;
        case caseCreateAction.CLEAR_COUNTERPARTY:
            state = {
                ...state,
                createCounterParty: false,
                selectedCounterparty: {}
            };
            break;
        case caseCreateAction.SEARCH_CORPORATE_RESULTS_FAILURE:

            state = {
                ...state,
                searchParam: action
            };
            break;
        case caseCreateAction.SEARCH_CORPORATE_RESULTS_SUCCESS:

            state = {
                ...state,
                corporate: action.data
            };
            break;
        case caseCreateAction.SEARCH_COUNTERPARTY_PARAMETER:
            state = {
                ...state,
                counterpartyLoading: true,
                counterpartyPageNo: action.pageNo,
                counterpartyPageSize: action.pageSize,
                counterpartySearchContext: {
                    parameter: action.parameter,
                    search: action.search,
                    countryCode: action.countryCode,
                    countryName: action.countryName
                }
            };
            break;
        case caseCreateAction.SEARCH_COUNTERPARTY_RESULTS_FAILURE:

            state = {
                ...state,
                counterparty: action.data,
                counterpartyLoading: false
            };
            break;
        case caseCreateAction.SEARCH_COUNTERPARTY_RESULTS_SUCCESS:
            const newData = action.data || [];
            const hasNext = newData.length >= state.counterpartyPageSize;
            state = {
                ...state,
                counterparty: newData,
                counterpartyHasNext: hasNext,
                counterpartyLoading: false
            };
            break;
        case caseCreateAction.RESET_COUNTERPARTY_PAGINATION:
            state = {
                ...state,
                counterparty: [],
                counterpartyPageNo: 1,
                counterpartyHasNext: false,
                counterpartyLoading: false,
                counterpartySearchContext: null
            };
            break;
        case caseCreateAction.GET_COUNTERPARTY_TYPE_SUCCESS:
            state = {
                ...state,
                dropdownData: action.data
            };
            break;
        case caseCreateAction.GET_COUNTERPARTY_TYPE_FAILURE:
            state = {
                ...state,
                dropdownData: []
            };
            break;
        case caseCreateAction.GET_REPORT_CATEGORY_SUCCESS:
            state = {
                ...state,
                reportCategorytData: action.data
            };
            break;
        case caseCreateAction.GET_REPORT_CATEGORY_FAILURE:
            state = {
                ...state,
                reportCategorytData: []
             };
            break;
        case caseCreateAction.GET_REPORT_FRONT_COVER_LIST_SUCCESS:
            state = {
                ...state,
                reportFrontCoverList: action.data
            };
            break;
        case caseCreateAction.GET_REPORT_FRONT_COVER_LIST_FAILURE:
            state = {
                ...state,
                reportFrontCoverList: []
             };
            break;
        case caseCreateAction.GET_PORTFOLIO_COUNT_SUCCESS:
            state = {
                ...state,
                portfolioCountData: action.data
            };
            break;
        case caseCreateAction.GET_PORTFOLIO_COUNT_FAILURE:
            state = {
                ...state,
                portfolioCountData: []
             };
            break;
        case caseCreateAction.GET_PRODUCTS_SUCCESS:
            state = {
                ...state,
                products: action.data
            };
            break;//
        case caseCreateAction.GET_PRODUCTS_FAILURE:
            state = {
                ...state,
                productsFailure: action.data
            };
            break;
        case caseCreateAction.GET_ALLDIVISIONSUBSIDIARY_SUCCESS:
            state = {
                ...state,
                 allDivisionSubsidiary: action.data
            };
            break;//
        case caseCreateAction.GET_ALLDIVISIONSUBSIDIARY_FAILURE:
            state = {
                ...state,
                 allDivisionSubsidiaryFailure: action.data
            };
            break;
        case caseCreateAction.GET_USERS_SUCCESS:
            state = {
                ...state,
                users: action.data
            };
            break;
        case caseCreateAction.GET_USERS_FAILURE:
            state = {
                ...state,
                users: action.data
            };
            break;
        case caseCreateAction.CREATE_COUNTERPARTY_SUCCESS:
            state = {
                ...state,
                createdCounterParty: action.data,
                createCounterParty: true
            };
            break;
        case caseCreateAction.CREATE_COUNTERPARTY_FAILURE:
            state = {
                ...state,
                createdCounterParty: action,
                createCounterParty: false
            };
            break;
        case caseCreateAction.CREATE_CASE_SUCCESS:
            state = {
                ...state,
                result: action
            };
            break;
        case caseCreateAction.CREATE_CASE_FAILURE:
            state = {
                ...state,
                result: action
            };
            break;
        case caseCreateAction.GET_ZONE_SUCCESS:
            state = {
                ...state,
                zoneList: action.data
            };
            break;
        case caseCreateAction.GET_ZONE_FAILURE:

            state = {
                ...state,
                zoneList: []
            };
            break;
            case caseCreateAction.GET_ZONE_FOR_STATE_SUCCESS:
                state = {
                    ...state,
                    zoneForState: action.data
                };
                break;
            case caseCreateAction.GET_ZONE_FOR_STATE_FAILURE:
    
                state = {
                    ...state,
                    zoneForState: undefined
                };
                break;
        case caseCreateAction.GET_INDIANSTATES_SUCCESS:
            state = {
                ...state,
                statesList: action.data
            };
            break;
        case caseCreateAction.GET_INDIANSTATES_FAILURE:

            state = {
                ...state,
                statesList: action
            };
            break;
        case caseCreateAction.CREATE_SUBSCRIPTION_DATABASE_CASE_SUCCESS:
            state = {
                ...state,
                result: action
            };
            break;
        case caseCreateAction.CREATE_SUBSCRIPTION_DATABASE_CASE_FAILURE:
            state = {
                ...state,
                result: action
            };
            break;
        default: return state
    }
    return state;
};

export default caseCreateReducer; 